import axios from 'axios';
import { updateEditAction } from '@/main/store/actionsFunctions';
import { ERROR } from '@/main/store/actionTypes';
import { ProdejNovychVozu } from '@/modules/noveVozy/prodejNovychVozu';
import { SkladNovychVozu } from '@/modules/noveVozy/skladNovychVozu';
import { apiProvider as providerPartner } from '@/modules/kartoteka/partner/api';
import { apiProvider as providerVozidlo } from '@/modules/kartoteka/vozidlo/api';
import { END_LOADING, START_LOADING, TABLE_DATA, START_LOADING_V2, END_LOADING_V2 } from '@/main/store/listEditTypes';
import { reportUrl } from '@/main/baseApi';

import { VYDEJKA, DMS_MODULE, GDPR, VYDEJKAND, ZAKAZKA_ND, PENDING_JOB_LIST, CAMPAIGN_DETAILS, ZAKAZKA_DRUH, ORDER_SUB_TYPES } from '../../constants';
import { apiProvider } from '../../api';
import { apiProvider as nahradniDilyApiProvider } from '../../nahradniDily/api';
import { types } from '../types';
import { State } from './state';

type VuexProps = { commit: any, dispatch: any, state: State };

export const actions = <const>{
	[types.actions.ZAKAZNICKA_SKUPINA_CHANGE]: ({ commit, state, dispatch }: VuexProps) => updateEditAction(
		state,
		commit,
		dispatch,
		apiProvider.zakaznickaSkupinaChange(state.edit),
	),

	[types.actions.FAKTURACNI_PROFIL_CHANGE]: ({ commit, state, dispatch }: VuexProps) => updateEditAction(
		state,
		commit,
		dispatch,
		apiProvider.fakturacniProfilChange(state.edit),
	),

	[types.actions.INT_PODIL_CHANGE]: ({ commit, state, dispatch }: VuexProps) => updateEditAction(
		state,
		commit,
		dispatch,
		apiProvider.intPodilChange(state.edit),
	),
	[types.actions.ZAK_PODIL_CHANGE]: ({ commit, state, dispatch }: VuexProps) => updateEditAction(
		state,
		commit,
		dispatch,
		apiProvider.zakPodilChange(state.edit),
	),

	[types.actions.GET_FAKTURACNI_PODILY]: async ({ commit, state, dispatch }: VuexProps) => {
		const podily = await updateEditAction(
			state,
			commit,
			dispatch,
			apiProvider.getPodily(state.edit.ZakazkaId!),
		);
		if (podily.PodilInt) {
			await dispatch(types.actions.INT_PODIL_CHANGE);
			commit(types.mutations.SHOW_ITN_CARD, true);
		}
	},

	[types.actions.VOZIDLO_CHANGE]: async ({ commit, state, dispatch } : VuexProps) => {
		if (state.edit.EnableRegionFlag) {
			dispatch(types.actions.ZAKAZNIK_FIRST_VISIT_CHECK);
		}
		state.edit.IsCustRevisit = false;
		const zakazka = await updateEditAction(
			state,
			commit,
			dispatch,
			apiProvider.vozidloChange(state.edit),
		);
		if (zakazka.data.VozidloVin != null) {
			const vinData = await updateEditAction(
				state,
				commit,
				dispatch,
				apiProvider.isWatchlistedVIN(zakazka.data.VozidloVin),
			);
			state.edit.WatchlistFlag = vinData.data.WatchlistFlag;
			if (vinData.data.WatchlistFlag) {
				state.localState.notificationDialogforWatchlisted = true;
				state.localState.notificationDialogforWatchlistedMsg = vinData.data.NotificationMessage;
			}
			const { data: orderSubType } = await apiProvider.getOrderSubType(state.edit.VyrobekvozOzn!);
		 	state.dropdownList.OrderSubType = orderSubType;
			const subtypeId = state.edit.OrderSubtypeId;
			const subtypeList = state.dropdownList.OrderSubType;
			if (subtypeId !== null || subtypeId !== 0) {
				const exists = subtypeList.some(item => item.Value === subtypeId);
			   	if (!exists) {
					state.edit.OrderSubtypeId = 0;
			  	}
			}
			if(state.edit.ZakazkaDruh === ZAKAZKA_DRUH.DILENSKA) {
				const contactDetailsResponse = await apiProvider.getCustomerContactDetails(state.edit.VozidloId!, state.edit.ZakaznikId!);
				if (contactDetailsResponse.data) {
					state.edit.CustomerContactDetails = contactDetailsResponse.data;
					state.edit.SelectedCustomerContactDetail = contactDetailsResponse.data.find((detail: any) => detail.ContactTypeId === 1) || null; //TODO: here 1 is hardcoded for primary contact type "OWNER"
					state.edit.ContactTypeId = 1; //state.edit.SelectedCustomerContactDetail ? state.edit.SelectedCustomerContactDetail.contactTypeId : null;
					state.dropdownList.ContactTypes = contactDetailsResponse.data.map((detail: any) => ({ Value: detail.ContactTypeId, Text: detail.ContactTypeText }));
				}
			}
		}
		await dispatch(`${PENDING_JOB_LIST}_TABLE_DATA`, { filter: { VozidloId: state.edit.VozidloId, ZakazkaId: state.edit.ZakazkaId } });

		if (zakazka.data.ZakaznikId && zakazka.data.VozidloId) {
			dispatch(`${GDPR}_TABLE_DATA`, { filter: { VyrobekvozOzn: state.edit.VyrobekvozOzn, ZakaznikId: state.edit.ZakaznikId } });
			// dispatch(types.actions.GET_DMZ_CDB);TODO:-- Not required now as CDB is not there
			// dispatch(types.actions.CDB_PREPAID_SERVICE);TODO:-- Not required now as CDB is not there
			// dispatch(types.actions.ZAKAZNIK_CDB_STATUS);TODO:-- Not required now as CDB is not there
		}
		state.localState.ShowDialogPendingJoblist = true;

		if (zakazka.data.VozidloVin) {
			if (state.edit.OrderSubtypeId !== ORDER_SUB_TYPES.PDI_V && (state.edit.ZakazkaDruh === ZAKAZKA_DRUH.PRODEJ_ZBOZI || state.edit.ZakazkaDruh === ZAKAZKA_DRUH.DILENSKA)) {
				dispatch(types.actions.GET_CAMPAIGN_DETAILS);
			}
		}
		//TODO: To call contact change api
		// TP1/TODO: az bude hotov BE endPoint na showWarning, ktery se plni z techto callu tak ho po skonceni vsech callu volat
	},

	async [types.actions.ZAKAZNIK_CHANGE]({ commit, state, dispatch }: VuexProps) {
		const zakaznik = await updateEditAction(
			state,
			commit,
			dispatch,
			apiProvider.zakaznikChange(state.edit),
		);
		//TODO: To call contact change api
		if (zakaznik.data.ZakaznikId) {
			dispatch(`${GDPR}_TABLE_DATA`, { filter: { VyrobekvozOzn: state.edit.VyrobekvozOzn, ZakaznikId: zakaznik.data.ZakaznikId } });
			// dispatch(types.actions.ZAKAZNIK_CDB_STATUS);---- Not required now as CDB is not there
		}
	},

	[types.actions.PROVOZOVNA_CHANGE]: ({ commit, state, dispatch }: VuexProps) => updateEditAction(
		state,
		commit,
		dispatch,
		apiProvider.provozovnaChange(state.edit),
	),

	[types.actions.JINY_PRIJEMCE_CHANGE]: ({ commit, state, dispatch }: VuexProps) => updateEditAction(
		state,
		commit,
		dispatch,
		apiProvider.jinyPrijemceChange(state.edit),
	),

	[types.actions.POJISTOVNA_CHANGE]: ({ commit, state, dispatch }: VuexProps) => updateEditAction(
		state,
		commit,
		dispatch,
		apiProvider.pojistovnaChange(state.edit),
	),

	[types.actions.LEASING_CHANGE]: ({ commit, state, dispatch }: VuexProps) => updateEditAction(
		state,
		commit,
		dispatch,
		apiProvider.leasingChange(state.edit),
	),

	[types.actions.SMLUVNI_PARTNER_CHANGE]: ({ commit, state, dispatch }: VuexProps) => updateEditAction(
		state,
		commit,
		dispatch,
		apiProvider.smluvniPartnerChange(state.edit),
	),

	[types.actions.SMLUVNI_PARTNER_TYP_CHANGE]: ({ commit, state, dispatch }: VuexProps) => updateEditAction(
		state,
		commit,
		dispatch,
		apiProvider.smluvniPartnerTypChange(state.edit),
	),

	// Interni zakazka
	[types.actions.INTERNI_ZAKAZNICKA_SKUPINA_CHANGE]: ({ commit, state, dispatch }: VuexProps) => updateEditAction(
		state,
		commit,
		dispatch,
		apiProvider.interniZakaznickaSkupinaChange(state.edit),
	),

	[types.actions.INTERNI_FAKTURACNI_PROFIL_CHANGE]: ({ commit, state, dispatch }: VuexProps) => updateEditAction(
		state,
		commit,
		dispatch,
		apiProvider.interniFakturacniProfilChange(state.edit),
	),

	[types.actions.INTERNI_DRUH_CHANGE]: ({ commit, state, dispatch }: VuexProps) => updateEditAction(
		state,
		commit,
		dispatch,
		apiProvider.interniDruhChange(state.edit),
	),

	[types.actions.LOAD_PACKETS]: ({ commit, state, dispatch }: VuexProps) => updateEditAction(
		state,
		commit,
		dispatch,
		apiProvider.slevaChange(state.edit), // TODO : smazat
		// apiProvider.loadPackets(state.ZakazkaEdit.Edit.ZakazkaId, state.ZakazkaEdit.Edit.VozidloId), // TODO neexistuje
	),

	[types.actions.SLEVA_CHANGE]: ({ commit, state, dispatch }: VuexProps) => updateEditAction(
		state,
		commit,
		dispatch,
		apiProvider.slevaChange(state.edit),
	),
	// TODO
	// [types.actions.ZAKAZNIK_CDB_STATUS]: async ({ commit, state }: VuexProps) => {
	// 	const status = await providerPartner.zakaznikGetCdb(state.edit.ZakaznikId!);
	// 	commit(types.mutations.ZAKAZNIK_CDB, status);
	// },

	[types.actions.ZAKAZNIK_FIRST_VISIT_CHECK]: async ({ commit, state } : VuexProps) => {
		const result = await apiProvider.customerFirstVisitCheck(state.edit.VozidloId ? state.edit.VozidloId : 0);
		commit(types.mutations.ZAKAZNIK_CUSTOMER_FIRST_VISIT, result);
	},

	[types.actions.GET_CAMPAIGN_DETAILS]: async ({ commit, state } : VuexProps) => {
		const result = await apiProvider.getCampaignDetails(state.edit.VozidloVin || '', state.edit.ZakazkaId || 0);
		commit(types.mutations.GET_CUSTOMER_CAMPAIGN_DETAILS, result);
	},
	// TODO
	// [types.actions.GET_DMZ_CDB]: ({ commit, state, dispatch } : VuexProps) => updateEditAction(
	// 	state,
	// 	commit,
	// 	dispatch,
	// 	providerVozidlo.vozidloGetCdbDmz(state.edit.VozidloId!),
	// ),

	// [types.actions.CDB_PREPAID_SERVICE]: ({ commit, state, dispatch }: VuexProps) => updateEditAction(
	// 	state,
	// 	commit,
	// 	dispatch,
	// 	providerVozidlo.vozidloCdbPrepaidService(state.edit.VozidloId!),
	// ),


	[types.actions.GET_DMZ]: ({ commit, state, dispatch }: VuexProps) => updateEditAction(
		state,
		commit,
		dispatch,
		apiProvider.getDMZ(state.edit.ZakazkaId!),
	),

	[types.actions.ZAKAZKA_PNV_CHANGE]: ({ commit, state, dispatch }: VuexProps) => updateEditAction(
		state,
		commit,
		dispatch,
		apiProvider.zmenaPnv(state.edit),
	),

	[types.actions.ZAKAZKA_POV_CHANGE]: ({ commit, state, dispatch }: VuexProps) => updateEditAction(
		state,
		commit,
		dispatch,
		apiProvider.zmenaPov(state.edit),
	),

	[types.actions.ZAKAZKA_NV_CHANGE]: ({ commit, state, dispatch }: VuexProps) => updateEditAction(
		state,
		commit,
		dispatch,
		apiProvider.zmenaNVozidlo(state.edit),
	),

	[types.actions.ZAKAZKA_OV_CHANGE]: ({ commit, state, dispatch } : VuexProps) => {
		dispatch(types.actions.ZAKAZNIK_FIRST_VISIT_CHECK);
		// Commenting below code for impact analysis.
		// if (state.edit.ZakazkaDruh === ZAKAZKA_DRUH.PRODEJ_ZBOZI || state.edit.ZakazkaDruh === ZAKAZKA_DRUH.DILENSKA) {
		// 	dispatch(types.actions.GET_CAMPAIGN_DETAILS);
		// }
		updateEditAction(
			state,
			commit,
			dispatch,
			apiProvider.zmenaOvozidlo(state.edit),
		);
	},
	[types.actions.ZAKAZKA_NVSKLAD_CHANGE]: ({ commit, state, dispatch } : VuexProps) => updateEditAction(
		state,
		commit,
		dispatch,
		apiProvider.zmenaNvSklad(state.edit),
	),

	async [types.actions.LOAD_MDV_VOZIDLO]({ commit, state, dispatch }: VuexProps) {
		try {
			commit(START_LOADING);
			const nvozidlo = await SkladNovychVozu.apiProvider.entity(state.edit.NvskladId!);
			commit(types.mutations.LOAD_MDV_VOZIDLO, { data: nvozidlo.data });
		} catch (err) {
			dispatch(ERROR, { moduleKey: DMS_MODULE, err }, { root: true });
		} finally {
			commit(END_LOADING);
		}
	},

	async [types.actions.LOAD_MDV_PNV]({ commit, state, dispatch }: VuexProps) {
		try {
			commit(START_LOADING);
			const pnv = await ProdejNovychVozu.apiProvider.entity(state.edit.PnvId!);
			commit(types.mutations.LOAD_MDV_PNV, { data: pnv.data });
		} catch (err) {
			dispatch(ERROR, { moduleKey: DMS_MODULE, err }, { root: true });
		} finally {
			commit(END_LOADING);
		}
	},
	async [types.actions.UPRAVA_POLOZKY_CHECK]({ commit, state, dispatch }: VuexProps, data: any) {
		try {
			commit(START_LOADING);
			const polozkyCheckResp = await apiProvider.upravaPolozkyCheck(data);
			commit(types.mutations.ZAKAZKA_UPRAVA_POLOZKY, { data: polozkyCheckResp.data });
		} catch (err) {
			dispatch(ERROR, { moduleKey: DMS_MODULE, err }, { root: true });
		} finally {
			commit(END_LOADING);
		}
	},
	async [types.actions.NABIDKA_NA_PRIPRAVU_CHANGE]({ commit, state, dispatch }: VuexProps) {
		try {
			commit(START_LOADING);
			await apiProvider.prevedNabidkuDoPripravy(state.edit);
			await updateEditAction(
				state,
				commit,
				dispatch,
				apiProvider.entity(state.edit.ZakazkaId!),
			);
			await dispatch(`${ZAKAZKA_ND}_${TABLE_DATA}`);
		} catch (err) {
			dispatch(ERROR, { moduleKey: DMS_MODULE, err }, { root: true });
		} finally {
			commit(END_LOADING);
		}
	},
	async [types.actions.PRIPRAVA_NA_OTEVRENOU_CHANGE]({ commit, state, dispatch }: VuexProps) {
		try {
			commit(START_LOADING);
			await apiProvider.prevodNaOtevrenou(state.edit);
			await updateEditAction(
				state,
				commit,
				dispatch,
				apiProvider.entity(state.edit.ZakazkaId!),
			);
		} catch (err) {
			dispatch(ERROR, { moduleKey: DMS_MODULE, err }, { root: true });
		} finally {
			commit(END_LOADING);
		}
	},

	async [types.actions.UVOLNENA_NA_OTEVRENOU_CHANGE]({ commit, state, dispatch }: VuexProps) {
		try {
			commit(START_LOADING);
			await apiProvider.uvolnenaToOtevrena(state.edit);
			await updateEditAction(
				state,
				commit,
				dispatch,
				apiProvider.entity(state.edit.ZakazkaId!),
			);
		} catch (err) {
			dispatch(ERROR, { moduleKey: DMS_MODULE, err }, { root: true });
		} finally {
			commit(END_LOADING);
		}
	},

	async [types.actions.CHANGE_TO_KULANCE]({ commit, state, dispatch }: VuexProps) {
		try {
			commit(START_LOADING);
			await apiProvider.changeToKulance(state.edit);
			await updateEditAction(
				state,
				commit,
				dispatch,
				apiProvider.entity(state.edit.ZakazkaId!),
			);
		} catch (err) {
			dispatch(ERROR, { moduleKey: DMS_MODULE, err }, { root: true });
		} finally {
			commit(END_LOADING);
		}
	},

	async [types.actions.CHANGE_TO_GARANCE]({ commit, state, dispatch }: VuexProps) {
		try {
			commit(START_LOADING);
			await apiProvider.changeToGarance(state.edit);
			await updateEditAction(
				state,
				commit,
				dispatch,
				apiProvider.entity(state.edit.ZakazkaId!),
			);
		} catch (err) {
			dispatch(ERROR, { moduleKey: DMS_MODULE, err }, { root: true });
		} finally {
			commit(END_LOADING);
		}
	},

	async [types.actions.GET_JDNF_COUT]({ commit, state, dispatch }: VuexProps) {
		try {
			state.localState.frontaNDCount = (await apiProvider.getJdnfCount(state.edit.ZakazkaId!)).data;
		} catch (err) {
			dispatch(ERROR, { moduleKey: DMS_MODULE, err }, { root: true });
		}
	},

	async [types.actions.GET_PAKETY_COUT]({ commit, state, dispatch }: VuexProps) {
		try {
			state.localState.paketyCount = (await apiProvider.getPaketyCount(state.edit.ZakazkaId!)).data;
		} catch (err) {
			dispatch(ERROR, { moduleKey: DMS_MODULE, err }, { root: true });
		}
	},

	async [types.actions.CHANGE_TO_INTERNI]({ commit, state, dispatch }: VuexProps) {
		try {
			commit(START_LOADING);
			await apiProvider.changeToInterni(state.edit);
			await updateEditAction(
				state,
				commit,
				dispatch,
				apiProvider.entity(state.edit.ZakazkaId!),
			);
		} catch (err) {
			dispatch(ERROR, { moduleKey: DMS_MODULE, err }, { root: true });
		} finally {
			commit(END_LOADING);
		}
	},

	async [types.actions.VEHICLE_INFORMATION_CHECK]({ commit, state, dispatch }: VuexProps) {
		try {
			if(state.edit.IsElsaREnabled === false) {
				return;
			}
			commit(START_LOADING_V2, 'localState.carDescription');
			const { data: serviceEnabled } = await apiProvider.getIsCarInfoEnabled(state.edit.VozidloId!);
			if (!serviceEnabled) { return; }

			const resp = await apiProvider.getCarDescriptionAsDto(state.edit.ZakazkaId!);
			commit(types.mutations.SET_CAR_DESCRIPTION, { data: resp.data });
		} catch (err) {
			if (axios.isCancel(err)) return;
			dispatch(ERROR, { moduleKey: DMS_MODULE, err }, { root: true });
		} finally {
			commit(END_LOADING_V2, 'localState.carDescription');
		}
	},
	async [types.actions.PRINT_VYDEJKA_ND]({ commit, state, dispatch }: VuexProps) {
		try {
			commit(START_LOADING);
			const { data } = await nahradniDilyApiProvider.tiskVydejka(state.edit.ZakazkaId!);
			await Promise.all([dispatch(`${VYDEJKA}_${TABLE_DATA}`), dispatch(`${VYDEJKAND}_${TABLE_DATA}`)]);
			if (data.length) {
				if (state.edit.VydejkaPrpt) {
					commit(types.mutations.SET_TISK_DIALOG, {
						filter: { id: data.pop() },
						url: reportUrl('GetVydejkaNDReport'),
						visible: true,
					});

					return true;
				}
			}
			return false;
		} catch (err) {
			dispatch(ERROR, { moduleKey: DMS_MODULE, err }, { root: true });
			return false;
		} finally {
			commit(END_LOADING);
		}
	},
	async [types.actions.CANCEL_SERVICE_PACKAGE]({ commit, state, dispatch } : VuexProps) {
		try {
			commit(START_LOADING);
			const result = await nahradniDilyApiProvider.cancelSP({
				zaznamId: state.edit.ZaznamId!,
				cancellationReason: state.edit.CancellationReason!,
				cancellationType: state.edit.CancellationReasonType!,
			});
			return result;
		} catch (err) {
			dispatch(ERROR, { moduleKey: DMS_MODULE, err }, { root: true });
			return false;
		} finally {
			commit(END_LOADING);
		}
	},
};
